import React from 'react';

export default function TerminationPolicy() {
  return (
    <div className="bg-white text-gray-800 min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-10">
        <h1 className="text-3xl text-center font-bold text-purple-600">Account Suspension & Termination Policy</h1>

        <p className="text-gray-700">
          This policy outlines the rules, process, and consequences of suspending or terminating any user or service provider account inside Million2Trillion (M2T).
        </p>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">Grounds for Suspension or Termination</h2>
          <ul className="list-disc text-gray-700 space-y-2 pl-6">
            <li>Violation of any M2T legal, compliance, or verification policies.</li>
            <li>Fraudulent activity, financial misrepresentation, or user scamming.</li>
            <li>Unethical trading practices, market manipulation, or insider collusion.</li>
            <li>Repeated user complaints or dispute resolutions proving violation.</li>
            <li>Failure to complete KYC or periodic compliance reviews.</li>
            <li>Non-payment of required platform fees or commission fraud.</li>
            <li>Abuse, harassment, or unethical behavior toward other verified members.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">Account Review Process</h2>
          <ul className="list-disc text-gray-700 space-y-2 pl-6">
            <li>Accounts flagged for investigation may be temporarily suspended pending internal compliance review.</li>
            <li>M2T may request supporting documents, explanations, or third-party audits before making a final termination decision.</li>
            <li>In certain serious cases, immediate permanent bans may be enforced without prior notice to protect market participants.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">Effect of Termination</h2>
          <ul className="list-disc text-gray-700 space-y-2 pl-6">
            <li>Loss of all platform access, revenue generation, monetization privileges, and public visibility on M2T.</li>
            <li>Frozen payouts or escrow balances until any outstanding obligations are fully cleared.</li>
            <li>Permanent blacklist status from re-registering new verified accounts.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">Appeal Rights</h2>
          <ul className="list-disc text-gray-700 space-y-2 pl-6">
            <li>Users may submit a one-time written appeal for internal review if they believe termination was applied unfairly or in error.</li>
            <li>M2T reserves full discretion on final reinstatement decisions after reviewing all submitted evidence.</li>
          </ul>
        </div>

        <p className="text-gray-500 italic pt-6">
          Protecting verified market trust requires strict enforcement of platform standards. Permanent account bans protect all honest verified users worldwide.
        </p>
      </div>
    </div>
  );
}
